import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import { fetchText$ } from '@atlassian/jira-servicedesk-common/src/utils/fetch';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	baseUrl: string,
	ruleSetId: number,
): Observable<number> => // Automation returns 200 on delete without any content. Since it does not have a "no content"
	// status, fetchJson$ expects content to exist and blows up trying to parse it.
	// Use fetchText$ instead, which handles no content safely.
	fetchText$(`${baseUrl}/rest/servicedesk/automation/1/ruleset/${ruleSetId}`, {
		method: 'DELETE',
	}).mergeMap(() => Observable.of(ruleSetId));
